module.exports = __webpack_public_path__ + "img/inspector-panel.c1f87c3d.png";